/** Keep the full causal tree in storage while presenting only expanded branches. */
export function visibleFuturesWheelGraph(nodes = [], edges = []) {
  const byId = new Map(nodes.map((node) => [String(node.id), node]));
  const children = new Map();
  for (const edge of edges) {
    const source = String(edge.source);
    const target = String(edge.target);
    if (!byId.has(source) || !byId.has(target)) continue;
    children.set(source, [...(children.get(source) || []), target]);
  }
  const root = nodes.find((node) => node.data?.semantic_data?.futures_wheel?.order === 0);
  if (!root) return { nodes: [], edges: [], hidden: new Set() };
  const shown = new Set();
  const visit = (id) => {
    if (shown.has(id)) return;
    shown.add(id);
    if (byId.get(id)?.data?.semantic_data?.collapsed === true) return;
    for (const child of children.get(id) || []) visit(child);
  };
  visit(String(root.id));
  return {
    nodes: nodes.filter((node) => shown.has(String(node.id))),
    edges: edges.filter((edge) => shown.has(String(edge.source)) && shown.has(String(edge.target))),
    hidden: new Set(nodes.map((node) => String(node.id)).filter((id) => !shown.has(id))),
  };
}
